import { EmployeeTypesDTO } from "./employee-type.dto";
import { Injectable } from "@nestjs/common";
import { EmployeeTypes } from "../employee-type.entity";

@Injectable()
export class EmployeeTypesAdapter{
     
    public convertDtoToEntity(dto: EmployeeTypesDTO, isUpdate: boolean = false): EmployeeTypes{
        const entity = new EmployeeTypes();
        entity.employeeTypesId = dto.employeeTypesId;
        entity.employeeTypes = dto.employeeTypes;
        entity.isActive = dto.isActive == undefined ? true: dto.isActive;
        if(isUpdate){
            entity.updatedUser = dto.updatedUser;
        }else{
            entity.isActive = true;
            entity.createdUser = dto.createdUser;
        }
        return entity;
    }

    public convertEntityToDto(entity: EmployeeTypes): EmployeeTypesDTO{
        const dto = new EmployeeTypesDTO;
        dto.employeeTypesId = entity.employeeTypesId;
        dto.employeeTypes = entity.employeeTypes;
        dto.isActive = entity.isActive;
        dto.createdAt = entity.createdAt;
        dto.createdUser = entity.createdUser;
        dto.updatedAt = entity.updatedAt;
        dto.updatedUser = entity.updatedUser;
        dto.versionFlag = entity.versionFlag;
        return dto;
    }
}